<template>
  <div class="search-page">
    <div class="page-body">
      <div class="search-header">
        <h1>{{ $t('view.search.resultTitle', { keyword }) }}</h1>
        <span class="result-count" v-if="results.length">{{ $t('view.search.resultCount', { total }) }}</span>
      </div>

      <div v-if="results.length" class="tool-grid">
        <ToolCard v-for="tool in results" :key="tool.id" :tool="tool" />
      </div>
      <el-empty v-else :description="$t('view.search.empty')">
        <div style="margin-top:12px;color:#909399;">
          {{ $t('view.search.emptyHintPrefix') }}<router-link to="/" style="color:#4e7cff;">{{ $t('view.search.emptyHintLink') }}</router-link>
        </div>
      </el-empty>
    </div>
  </div>
</template>

<script>
import ToolCard from '@/components/ToolCard'
import { searchTools } from '@/api/site'

export default {
  components: { ToolCard },
  created() { this.doSearch() },
  data() {
    return {
      keyword: '',
      results: [],
      total: 0
    }
  },
  methods: {
    doSearch() {
      this.keyword = this.$route.query.q || ''
      if (this.keyword) {
        searchTools({ name: this.keyword, pageNum: 1, pageSize: 50 }).then(res => {
          this.results = res.data || []
          this.total = res.total || 0
        })
      }
    }
  },
  watch: {
    '$route.query.q'() { this.doSearch() }
  }
}
</script>

<style scoped>
.search-page { background: #f5f7fa; }
.page-body { max-width: 1200px; margin: 0 auto; padding: 32px 20px 60px; }

.search-header {
  margin-bottom: 24px;
}
.search-header h1 { font-size: 24px; color: #303133; margin: 0 0 8px; }
.result-count { font-size: 13px; color: #909399; }

.tool-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
@media (max-width: 960px) { .tool-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 640px) { .tool-grid { grid-template-columns: 1fr; } }
</style>
